<!-- <div id="photoOptions">
  <b style="font-size: 16px;">Agent Photo</b>
  <input
    type="file"
    class="file-input"
    (change)="onImageSelected($event)"
    accept=".jpeg, .jpg, .png"
    #imgUpload
    name="image"
  />
  <div class="doc-upload" *ngIf="!hasImg; else elseBlock">
    <button
      mat-stroked-button
      class="seneca-button seneca-stroke-button BusRef1"
      color="primary"
      (click)="imgUpload.click()"
    >
      Upload
    </button>
  </div>
  <ng-template #elseBlock>
    <a (click)="viewImage()" color="red"><u>View</u></a>
    <a (click)="deleteImg()">
      <mat-icon>delete</mat-icon><span>Delete</span>
    </a>
  </ng-template>
</div> -->
<br><br>
<form class="form-container" [formGroup]="contactInfoForm" (ngSubmit)="save()">
  <input type="hidden" formControlName="agentId">
  <div class="form-group-left">
    <mat-form-field id="salutation" appearance="outline">
      <mat-label>Salutation</mat-label>
      <mat-select name="Salutation" formControlName="salutation">
          <mat-option *ngFor="let title of titles" [value]="title">{{title}}</mat-option>
      </mat-select>
      <mat-error><em class="error-hint"> Required</em></mat-error>
    </mat-form-field>
    <mat-form-field id="userType" appearance="outline">
      <mat-label>User Type</mat-label>
      <mat-select name="UserType" formControlName="userType">
          <mat-option value="Owner">Owner</mat-option>
          <mat-option value="Signing Officer">Signing Officer</mat-option>
      </mat-select>
      <mat-error><em class="error-hint"> Required</em></mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" id="job_title">
      <mat-label>Job Title</mat-label>
      <input matInput placeholder="Job Title" formControlName="jobTitle" maxlength="100">
      <mat-error>
        <em class="error-hint" *ngIf="contactInfoForm.get('jobTitle')?.hasError('required')"> Required</em>
        <em class="error-hint" *ngIf="contactInfoForm.get('jobTitle')?.hasError('pattern')"> Invalid job title</em>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="form-group-left">
    <mat-form-field appearance="outline" id="normalTextField">
      <mat-label>Last Name</mat-label>
      <input matInput placeholder="Last Name" formControlName="lastName" maxlength="100">
      <mat-error>
        <em class="error-hint" *ngIf="contactInfoForm.get('lastName')?.hasError('required')"> Required</em>
        <em class="error-hint" *ngIf="contactInfoForm.get('lastName')?.hasError('pattern')"> Invalid last name</em>
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" id="normalTextField">
      <mat-label>First Name</mat-label>
      <input matInput placeholder="First Name" formControlName="firstName" maxlength="100">
      <mat-error>
        <em class="error-hint" *ngIf="contactInfoForm.get('firstName')?.hasError('required')"> Required</em>
        <em class="error-hint" *ngIf="contactInfoForm.get('firstName')?.hasError('pattern')"> Invalid first name</em>
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-group-left">
    <mat-form-field id="normalTextField" appearance="outline">
        <mat-label>Country</mat-label>
        <mat-select name="Country" formControlName="country">
            <mat-option *ngFor="let country of countries" [value]="country.Code">{{country.Name}}</mat-option>
        </mat-select>
        <mat-error><em class="error-hint"> Required</em></mat-error>
    </mat-form-field>
    <mat-form-field id="province" appearance="outline">
        <mat-label>Province/State</mat-label>
        <input matInput placeholder="Province/State" formControlName="provinceOrState" maxlength="50">
    </mat-form-field>
  </div>
  <div class="form-group-left">
    <mat-form-field appearance="outline" id="normalTextField">
        <mat-label>Street Address 1</mat-label>
        <input matInput placeholder="Street Address Line 1" formControlName="addressOne" maxlength="150">
        <mat-error>
          <em class="error-hint" *ngIf="contactInfoForm.get('addressOne')?.hasError('required')"> Required</em>
          <em class="error-hint" *ngIf="contactInfoForm.get('addressOne')?.hasError('pattern')"> Cannot be blank</em>
        </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" id="normalTextField">
        <mat-label>Street Address 2</mat-label>
        <input matInput placeholder="Address Line 2" formControlName="addressTwo" maxlength="150">
    </mat-form-field>
  </div>
  <div class="form-group-left">
    <mat-form-field appearance="outline" id="normalTextField">
      <mat-label>City/Town</mat-label>
      <input matInput placeholder="City/Town" formControlName="city" maxlength="50">
      <mat-error>
        <em class="error-hint" *ngIf="contactInfoForm.get('city')?.hasError('required')"> Required</em>
        <em class="error-hint" *ngIf="contactInfoForm.get('city')?.hasError('pattern')"> Cannot be blank</em>
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" id="postalCode">
        <mat-label>Postal Code / ZIP</mat-label>
        <input matInput placeholder="M2J 2X5 (Ex. 12345)" formControlName="postalCode" maxlength="10">
    </mat-form-field>
  </div>
  <div class="form-group-left">
    <mat-form-field appearance="outline" id="phoneAreaCode">
      <mat-label>Country Code</mat-label>
      <input
          type="tel"
          matInput
          placeholder="Country Phone"
          formControlName="countryCode1"
        />
      <mat-error>
        <em class="error-hint" *ngIf="contactInfoForm.get('countryCode1')?.hasError('required')"> Required</em>
        <em class="error-hint" *ngIf="contactInfoForm.get('countryCode1')?.hasError('pattern')"> Optional + and 1–3 digits</em>
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" id="phoneTextBox">
        <mat-label>Phone Number</mat-label>
        <input type="tel" matInput placeholder="Primary Phone" formControlName="primaryPhone">
        <mat-icon matSuffix>phone</mat-icon>
        <mat-error>
          <em class="error-hint" *ngIf="contactInfoForm.get('primaryPhone')?.hasError('required')"> Required</em>
          <em class="error-hint" *ngIf="contactInfoForm.get('primaryPhone')?.hasError('pattern') || contactInfoForm.get('primaryPhone')?.hasError('minlength')"> 7–12 digits</em>
        </mat-error>
    </mat-form-field>
  </div>

  <div class="form-group-left">
    <mat-form-field appearance="outline" id="phoneAreaCode">
      <mat-label>Country Code</mat-label>
        <input
            type="tel"
            matInput
            placeholder="Country Phone"
            formControlName="countryCode2"
        />
        <mat-error>
          <em class="error-hint" *ngIf="contactInfoForm.get('countryCode2')?.hasError('pattern')"> Optional + and 1–3 digits</em>
        </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" id="phoneTextBox">
        <mat-label>Secondary Phone Number</mat-label>
        <input type="tel" matInput placeholder="Secondary Phone" formControlName="secondaryPhone">
        <mat-icon matSuffix>phone</mat-icon>
        <mat-error>
          <em class="error-hint" *ngIf="contactInfoForm.get('secondaryPhone')?.hasError('pattern')"> 7–12 digits</em>
        </mat-error>
    </mat-form-field>
  </div>
  <div class="form-group-left">
    <mat-form-field appearance="outline" id="textBoxTwo">
      <mat-label>Email</mat-label>
      <input type="email" matInput placeholder="Email" formControlName="email" maxlength="150">
      <mat-error>
        <em class="error-hint" *ngIf="contactInfoForm.get('email')?.hasError('required')"> Required</em>
        <em class="error-hint" *ngIf="contactInfoForm.get('email')?.hasError('email')"> Invalid email</em>
      </mat-error>
    </mat-form-field>
  </div>
  <div class="formButtons">
    <div class="actions-box">
      <mat-card-actions>
        <div>
          <button
            *ngIf="showFillTestDataButton"
            mat-stroked-button
            type="button"
            class="seneca-button"
            color="primary"
            (click)="fillTestData()"
          >
            <span>Fill Test Data</span>
          </button>
          <button
            mat-flat-button
            type="submit"
            class="seneca-button"
            [disabled]="contactInfoForm.invalid || isSaving"
            color="primary"
          >
            <span>{{ isSaving ? 'Saving...' : 'Save' }}</span>
          </button>


          <!-- <button mat-stroked-button id="buttonSeperator" type="buton" class="seneca-button red" color="primary"
                margin-left:20px (click)="cancel()">
              <span>Cancel</span>
            </button> -->
        </div>
      </mat-card-actions>
      <br />
    </div>
  </div>
</form>
